import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CImage,
  CLoadingButton,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from "@coreui/react-pro";
import { Formik } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import SModal from "../../shared/Modal/SModal";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AppDispatch } from "../../../store";
import { ToastSuccess } from "../../shared/toast/Toast";
import { createEntity, updateEntity } from "./productManagement.api";
import { fetching, resetEntity } from "./productManagement.reducer";
import { checkErrorInputFile } from "@/components/shared/AvatarUpload/AvatarUploadContainer";
import { ResponseStatus } from "@/shared/enumeration/ResponseStatus";
import { cisCameraPlus } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { INewProduct, IProduct } from "@/shared/model/product.model";
import { handleUploadImage } from "@/shared/utils/ultils";

interface IBankUpdateProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  productObj?: IProduct;
}

const BankUpdate = (props: IBankUpdateProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.productsReducer
  );
  const { updateEntitySuccess, loading } = initialState;
  const { visible, setVisible, productObj } = props;
  const handleOnClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (updateEntitySuccess) {
      setVisible(false);
      ToastSuccess(
        productObj ? "Cập nhật sản phẩm thành công" : "Tạo sản phẩm thành công"
      );
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const initialValues: INewProduct = {
    name: "",
    description: "",
    avatar: "",
    status: ResponseStatus.ACTIVE,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Không được để trống"),
  });

  const handleFileUploadAvatar = async (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void
  ) => {
    const inputFiles = e.target.files;
    if (inputFiles && inputFiles[0]) {
      if (!checkErrorInputFile([inputFiles[0]])) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        setFieldValue("fileAvatar", inputFiles[0]);
        setFieldValue("avatar", e.target?.result);
      };
      reader.readAsDataURL(inputFiles[0]);
    }
  };

  const handleRemappingImageValue = async (value: INewProduct) => {
    if (value.fileAvatar) {
      const avatarUrlPromises = await handleUploadImage(value.fileAvatar);
      value.avatar = avatarUrlPromises;
    }
    return value;
  };

  return (
    <SModal
      visible={visible}
      onClose={handleOnClose}
      backdrop="static"
      className="custom-modal"
    >
      <Formik
        initialValues={productObj || initialValues}
        validationSchema={validationSchema}
        // validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (value) => {
          const values = await handleRemappingImageValue(value);
          dispatch(fetching());
          if (productObj) {
            dispatch(updateEntity(values as IProduct));
          } else {
            dispatch(createEntity(values));
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
        }) => (
          <CForm onSubmit={handleSubmit} className="custom-form">
            <>
              <CModalHeader>
                {productObj ? "Chỉnh sửa sản phẩm" : "Tạo sản phẩm"}
              </CModalHeader>
              <CModalBody>
                <CRow className="g-3">
                  <CCol xs={12}>
                    <CRow>
                      <CCol xs={12}>
                        <CFormLabel className="fw-bold text-sm mb-2 required-field">
                          Chọn ảnh đại diện sản phẩm
                        </CFormLabel>
                        <div
                          className="d-flex justify-content-center"
                          style={{ background: "#f6f6f6" }}
                        >
                          <div className="profileImageContainer">
                            <div
                              className="position-relative"
                              style={{ height: 100 }}
                            >
                              {values.avatar ? (
                                <CImage
                                  color="secondary"
                                  rounded
                                  className="avatar-xxl object-fit-cover"
                                  src={values.avatar}
                                  style={{ width: "100%", height: "100%" }}
                                />
                              ) : (
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center"
                                  style={{ width: "100%", height: "100%" }}
                                >
                                  <CIcon
                                    icon={cisCameraPlus}
                                    className="mb-3"
                                    style={{ width: "33px", height: "33px" }}
                                  />
                                  <p>Chọn ảnh</p>
                                </div>
                              )}
                            </div>
                            <CFormLabel
                              htmlFor="custom-task-file-input"
                              className={`p-image`}
                            >
                              {values.avatar ? (
                                <CIcon
                                  icon={cisCameraPlus}
                                  color="secondary"
                                  className="upload-button"
                                />
                              ) : (
                                <div className="add-image"></div>
                              )}
                              <input
                                id="custom-task-file-input"
                                className="file-upload"
                                type="file"
                                onClick={(e) => (e.currentTarget.value = "")}
                                onChange={(e) =>
                                  handleFileUploadAvatar(e, setFieldValue)
                                }
                                // accept={inputFileTypesAccept}
                                accept="image/*"
                              />
                            </CFormLabel>
                          </div>
                        </div>
                        <CFormFeedback
                          invalid
                          className={
                            !!errors.avatar && touched.avatar
                              ? "d-block"
                              : "d-none"
                          }
                        >
                          {errors.avatar}
                        </CFormFeedback>
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol xs="12">
                    <CFormLabel className="mb-6 label-gray-700">
                      Tên sản phẩm
                    </CFormLabel>

                    <CFormInput
                      className="form-height-44"
                      name="name"
                      autoComplete="off"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.name && touched.name}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.name && touched.name ? "d-block" : "d-none"
                      }
                    >
                      {errors.name}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="12">
                    <CFormLabel className="mb-6 label-gray-700">
                      Mô tả
                    </CFormLabel>

                    <CFormTextarea
                      className="form-height-44"
                      name="description"
                      autoComplete="off"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.description && touched.description}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.description && touched.description
                          ? "d-block"
                          : "d-none"
                      }
                    >
                      {errors.description}
                    </CFormFeedback>
                  </CCol>
                </CRow>
              </CModalBody>
              <CModalFooter className="d-flex justify-content-end">
                <CButton
                  className="btn-custom minw-120 variant-gray-300"
                  type="button"
                  onClick={() => {
                    resetForm();
                    setVisible(false);
                  }}
                >
                  Huỷ
                </CButton>
                <CLoadingButton
                  className="btn-custom minw-120 primary-500"
                  type="submit"
                  loading={loading}
                  disabled={loading}
                >
                  Lưu
                </CLoadingButton>
              </CModalFooter>
            </>
          </CForm>
        )}
      </Formik>
    </SModal>
  );
};

export default BankUpdate;
